import { Copy, ExternalLink } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/modern/components/ui/button";
import { cn } from "@/modern/utils";

interface SitePublishUrlRowProps {
  url: string;
  className?: string;
}

export function SitePublishUrlRow({ url, className }: SitePublishUrlRowProps) {
  const href = url.startsWith("http") ? url : `https://${url}`;
  const display = href.replace(/^https?:\/\//, "");

  const copy = () => {
    void navigator.clipboard.writeText(href);
    toast.success("Copied to clipboard");
  };

  if (!display || display === "yoursite.com/your-slug") {
    return (
      <div className={cn("rounded-lg border border-dashed border-border bg-muted/20 px-3 py-2.5 text-xs text-muted-foreground", className)}>
        Set a slug to generate your preview URL
      </div>
    );
  }

  return (
    <div className={cn("flex items-center gap-1 rounded-lg border border-border bg-muted/30 px-2 py-1", className)}>
      <code className="min-w-0 flex-1 truncate px-1 text-xs text-foreground">{display}</code>
      <Button type="button" variant="ghost" size="icon-sm" onClick={copy} aria-label="Copy URL">
        <Copy className="size-3.5" />
      </Button>
      <Button type="button" variant="ghost" size="icon-sm" asChild aria-label="Open URL">
        <a href={href} target="_blank" rel="noopener noreferrer">
          <ExternalLink className="size-3.5" />
        </a>
      </Button>
    </div>
  );
}
